/**
 * @author: Abdul Pathan
 */
import React, { useState, useEffect } from "react";

import { Button, Row, Col, Container } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import schoolApi from "../../api/schoolApi";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { v4 as uuidv4 } from "uuid";

const EditAssignSubjectClass = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedClass, setSelectedClass] = useState(
    location?.state?.classId ? location?.state?.classId : ""
  );
  const [oldClassId, setOldClassId] = useState(location?.state?.classId);
  const [deleteRecords, setDeleteRecords] = useState([]);
  const [allSubjects, setAllSubjects] = useState([]);
  const [optionClass, setOptionClass] = useState([]);
  const [rowRecords, setRowRecords] = useState([]);

  useEffect(() => {
    async function init() {
      try {
      } catch (error) {
        toast.error(error.response.data.message);
      }
      const result = await schoolApi.getSubjectRecord();
      if (result) {
        const updatedRowRecords = result.map((item) => ({
          subject_id: item.id,
          subjectname: item.name,
          shortname: item.shortname,
          category: item.category,
          type: item.type,
        }));
        setAllSubjects(updatedRowRecords);
      } else {
        setAllSubjects([]);
      }

      const responce = await schoolApi.getActiveClassRecords();
      if (responce.success) {
        let ar = [];
        responce?.result?.map((item) => {
          ar.push({ value: item.class_id, label: item.classname });
        });
        setOptionClass(ar);
      } else {
        setOptionClass([]);
      }

      if (location?.state?.classId) {
        const responce = await schoolApi.getAssignSubjectClassIdByRecords(
          location?.state?.classId
        );
        if (responce.success) {
          const updatedRowRecords = responce.records.map((item) => ({
            uuid: uuidv4(),
            selectedSubject: {
              id: item.id,
              subject_id: item.subject_id,
              subjectname: item.subjectname,
              shortname: item.shortname,
              category: item.category,
              type: item.type,
            },
          }));
          updatedRowRecords.push({
            uuid: uuidv4(),
            selectedSubject: {
              id: "",
              subject_id: "",
              subjectname: "",
              shortname: "",
              category: "",
              type: "",
            },
          });
          setRowRecords(updatedRowRecords);
        } else {
          setRowRecords([]);
        }
      }
    }
    init();
  }, []);

  let subjectOptions = allSubjects.map((element) => ({
    value: element.subject_id,
    label: element.subjectname,
  }));

  const selectedClassName = async (e) => {
    setRowRecords([
      {
        uuid: uuidv4(),
        selectedSubject: {
          id: "",
          subject_id: "",
          subjectname: "",
          shortname: "",
          category: "",
          type: "",
        },
      },
    ]);
    const newSelectedClass = e.target.value;
    setSelectedClass(newSelectedClass);
    if (newSelectedClass) {
      const response = await schoolApi.getAllSubByClassId(newSelectedClass);
      if (response.success) {
        const updatedRowRecords = response.records.map((item) => ({
          uuid: uuidv4(),
          selectedSubject: {
            id: item.id,
            subject_id: item.subject_id,
            subjectname: item.subjectname,
            shortname: item.shortname,
            category: item.category,
            type: item.type,
          },
        }));
        updatedRowRecords.push({
          uuid: uuidv4(),
          selectedSubject: {
            id: "",
            subject_id: "",
            subjectname: "",
            shortname: "",
            category: "",
            type: "",
          },
        });
        setRowRecords(updatedRowRecords);
      }
    }
  };

  const removeRows = (rowId, item) => {
    const updatedRowRecord = rowRecords.filter(
      (rowItem) => rowItem.uuid !== rowId
    );

    if (rowRecords.length === 1) {
      toast.error("Cannot delete the last row.");
    } else {
      setRowRecords(updatedRowRecord);
      if (item?.selectedSubject?.subject_id) {
        setAllSubjects([...allSubjects, item.selectedSubject]);
      }
      if (item.selectedSubject.id) {
        setDeleteRecords([...deleteRecords, item.selectedSubject.id]);
      }
    }
  };

  const handleSubjectChange = (selectOption, rowId, item) => {
    const selectedSubject = allSubjects.find(
      (subject) => subject.subject_id === selectOption.value
    );

    let updatedAllSubjects;

    const updatedRowRecords = rowRecords.map((record) => {
      if (record.uuid === rowId) {
        updatedAllSubjects = allSubjects.filter(
          (subject) => subject.id !== selectOption.value
        );
        return { ...record, selectedSubject };
      } else {
        return record;
      }
    });

    const lastRow = updatedRowRecords[updatedRowRecords.length - 1];

    if (lastRow.selectedSubject.id !== "") {
      const newRow = {
        id: uuidv4(),
        selectedSubject: {
          id: "",
          name: "",
          shortname: "",
          category: "",
          type: "",
        },
      };
      updatedRowRecords.push(newRow);
    }

    setRowRecords(updatedRowRecords);
    setAllSubjects(updatedAllSubjects);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (deleteRecords && deleteRecords.length) {
      for (let obj of deleteRecords) {
        if (obj) {
          const result = await schoolApi.deleteAssignSubjectClassRecord(obj);
        }
      }
    }

    let array = [];

    rowRecords.forEach((item) => {
      if (!item?.selectedSubject?.id || selectedClass) {
        if (item?.selectedSubject?.subject_id || selectedClass) {
          array.push({
            old_class_id: oldClassId,
            assign_subject_id: item?.selectedSubject?.id,
            subject_id: item.selectedSubject.subject_id,
            class_id: selectedClass,
          });
        }
      }
    });


    if (array && array.length > 0) {
      for (let obj of array) {
        if (obj.subject_id) {
          const response = await schoolApi.updateAssignSubjectClassRecord(obj);
        }
      }
    }

    toast.success("Record Saved Succesfully!", {
      position: toast.POSITION.TOP_RIGHT,
    });
    navigate(`/assignsubjectclass`);
  };


  const handleCancel = () => {
    navigate(`/assignsubjectclass`);
  };

  return (
    <>
      <Row>
        <Col lg={10} className="mx-4">
          <Link className="nav-link" to="/assignsubjectclass">
            Home <i className="fa-solid fa-chevron-right"></i> Assign Subject
            Class
          </Link>
        </Col>
      </Row>

      <Container className="mt-5 pt-5">
        <Row className="mx-3">
          <Col></Col>
          <Col lg={10}>
            <Row className="view-form-header align-items-center">
              <Col lg={3}>Assign Subject Class</Col>
              <Col lg={9} className="d-flex justify-content-end">
                <Button
                  className="btn-sm mx-2"
                  variant="danger"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                <Button
                  className="btn-sm"
                  variant="success"
                  onClick={handleSubmit}
                >
                  Save
                </Button>
              </Col>
            </Row>
          </Col>
          <Col></Col>
        </Row>
      </Container>

      <Container>
        <Row className="mt-2 mx-3">
          <Col></Col>
          <Col lg={10}>
            <Row>
              <Col lg={3}>
                <Form.Group>
                  <Form.Label> Class Name </Form.Label>
                  <Form.Select
                    value={selectedClass}
                    name="class"
                    required
                    onChange={selectedClassName}
                  >
                    <option value="">-- Select Class --</option>
                    {optionClass.map((cls) => (
                      <option key={cls.value} value={cls.value}>
                        {cls.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Col>
          <Col></Col>
        </Row>
      </Container>

      <Container>
        <Row>
          <Col></Col>
          <Col lg={10}>
            <Row>
              {/* <Col lg={12}>
                <Button
                  className="btn float-end mx-3"
                  variant="primary"
                  onClick={addRows}
                >
                  Add Row
                </Button>
              </Col> */}

              <Form className="mt-3">
                <div className="container">
                  <div className="row clearfix">
                    <div className="col-md-12 column">
                      <table
                        className="table table-bordered table-hover"
                        id="tab_logic"
                      >
                        <thead>
                          <tr>
                            <th className="text-center">S.No.</th>
                            <th className="text-center">Subject Name</th>
                            <th className="text-center">Short Name</th>
                            <th className="text-center">Category</th>
                            <th className="text-center">Type</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {rowRecords &&
                            rowRecords.map((item, index) => (
                              <tr key={item.uuid}>
                                <td className="text-center">{index + 1}</td>
                                <td>
                                  <Select

                                    value={subjectOptions.find(
                                      (option) =>
                                        option.value ===
                                        (item?.selectedSubject &&
                                          item?.selectedSubject?.subject_id)
                                    )}
                                    onChange={(selectedOption) =>
                                      handleSubjectChange(
                                        selectedOption,
                                        item.uuid,
                                        item
                                      )
                                    }
                                    options={subjectOptions}
                                  />
                                </td>
                                <td>
                                  <input
                                    disabled
                                    className="form-control"
                                    type="text"
                                    name="shortname"
                                    value={
                                      item?.selectedSubject?.shortname || ""
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    disabled
                                    className="form-control"
                                    type="text"
                                    name="category"
                                    value={
                                      item?.selectedSubject?.category || ""
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    disabled
                                    className="form-control"
                                    type="text"
                                    name="type"
                                    value={item?.selectedSubject?.type || ""}
                                  />
                                </td>
                                <td>
                                  {item?.selectedSubject?.subject_id ? (
                                    <Button
                                      variant="danger"
                                      onClick={() =>
                                        removeRows(item.uuid, item)
                                      }
                                    >
                                      <i className="fa-regular fa-trash-can"></i>
                                    </Button>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </Form>
            </Row>
          </Col>

          <Col></Col>
        </Row>
      </Container>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default EditAssignSubjectClass;
